import { useRouter } from 'next/router'
import { PodCastAPI } from '../../../apis/PodcastAPI'
import { Container } from '../../../components/Container'
import LatestPodcasts from '../../../components/Podcasts/PodcastsWithPagination'
import ShallowHeader from '../../../components/ShallowHeader'

export default function TagPage({ tagData, podcasts }) {
    const router = useRouter()

    // console.log(tagData, podcasts)

    // Handle fallback state if the page hasn't been generated yet
    if (router.isFallback) {
        return <div>Loading...</div>
    }

    return (
        <Container>
            <ShallowHeader title={'Tag: ${tagData.name}'} />
            <p>{tagData?.description}</p>
            <LatestPodcasts
                title={`Tag: ${tagData.name}`}
                podcasts={podcasts}
            />
        </Container>
    )
}

// Fetching the slugs of all tags to generate the static paths
export async function getStaticPaths() {
    const tags = await PodCastAPI.getTags() // Adjust this to your API or WP fetch
    const paths = tags.map((tag) => ({
        params: { slug: tag.slug },
    }))

    return {
        paths,
        fallback: true, // Enable fallback to generate pages on demand
    }
}

// Fetching data for each tag based on the slug
export async function getStaticProps({ params }) {
    const tagData = await PodCastAPI.getTagBySlug(params.slug) // Fetch tag by slug
    const podcasts = await PodCastAPI.getPodcastsByTag(tagData.id) // Fetch podcasts by tag
    //testing
    // console.log(tagData, podcasts)

    if (!tagData || !podcasts) {
        return {
            notFound: true,
        }
    }

    return {
        props: {
            tagData,
            podcasts,
        },
        revalidate: 10, // Revalidate the page every 10 seconds
    }
}
